exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.remove-button[data-v-2a45b726] {\n  display: inline-block;\n}\n", ""]);

// exports
